import { Routes, Route } from "react-router-dom";
import "./styles/app.sass";
import Page from "./components/Page";
import Home from "./screens/Home";
import Result from "./screens/Result";
import Science from "./screens/Science";
import { Questionnaire } from "./utils/typeform";

function App() {
    return (
        <Routes>
            <Route path="/">
                <Route
                    index
                    element={
                        <Page>
                            <Home />
                        </Page>
                    }
                />
                <Route
                    path="result/:email"
                    element={
                        <Page>
                            <Result />
                        </Page>
                    }
                />
                <Route
                    path="science"
                    element={
                        <Page>
                            <Science />
                        </Page>
                    }
                />
                <Route
                    path="questionnaire"
                    element={
                        <Questionnaire />
                    }
                />
            </Route>
        </Routes>
    );
}

export default App;
